import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import Navbar from "../../../components/layout/Navbar/Navbar";
import Sidebar from "../../../components/layout/Sidebar/Sidebar";
import Header from "../../../components/layout/header/Header";
import ConfirmarConcessaoContent from "../../../components/Confirmar-Concessao/ConfirmarConcessaoContent";
import { getCargoIdSidebar } from "../../../constants/sidebarConfig";
import apiService from "../../../services/api";
import concessionWhite from "../../../assets/concessionWhite.png";

const NAVBAR_HEIGHT = 60;
const SIDEBAR_WIDTH = 300;

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: #ffffff;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex: 1;
  margin-top: 60px;
`;

const MainContent = styled.main`
  flex: 1;
  margin-left: ${SIDEBAR_WIDTH}px;
  overflow-y: auto;
  height: calc(100vh - ${NAVBAR_HEIGHT}px);
`;

const ConfirmarConcessao = () => {
  const [user, setUser] = useState(null);
  const [sidebarItems, setSidebarItems] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const solicitacaoIdFiltro = location.state?.solicitacaoId ?? null;
  const vagaIdFiltro = location.state?.vagaId ?? null;
  const onlyConfirmada = location.state?.onlyConfirmada ?? false;

  useEffect(() => {
    const fetchUser = async () => {
      try {
        // VERIFICAR PERMISSÕES PARA CARGOID 2 - PODE ACESSAR?
        const userData = await apiService.getCurrentUser();
        // if (userData?.cargoId !== 3) {
        //   navigate("/DashboardInicio", { replace: true });
        //   return;
        // }

        setUser(userData);
        const filteredItems = getCargoIdSidebar(userData.cargoId);
        setSidebarItems(filteredItems);
      } catch (err) {
        console.error("Erro ao buscar usuário:", err);
      }
    };

    fetchUser();
  }, [navigate]);

  return (
    <PageWrapper>
      <Navbar
        onLogout={apiService.logout}
        showHome={true}
        showNotifications={true}
        showProfile={true}
        showLogout={true}
        user={user}
      />
      <ContentWrapper>
        <Sidebar items={sidebarItems} />
        <MainContent>
          <Header
            prefixText="CONCESSÕES / VALIDAÇÕES"
            icon={concessionWhite}
            title="Confirmação de Concessões"
          />
          <ConfirmarConcessaoContent
            solicitacaoIdFiltro={solicitacaoIdFiltro}
            vagaIdFiltro={vagaIdFiltro}
            onlyConfirmada={onlyConfirmada}
          />
        </MainContent>
      </ContentWrapper>
    </PageWrapper>
  );
};

export default ConfirmarConcessao;
